/*
 * Featured Product
 * ----------------
 * Drives the offer-preset bundle selector in sections/featured-product.liquid.
 *
 * The section renders offer-preset cards (snippets/offer-preset-card.liquid) from
 * the product's custom.offer_presets metafield, mirroring the PDP. Each preset is a
 * quantity bundle. Selecting one highlights the card (clearing its siblings) and
 * writes the preset's quantity into the form's hidden input[name="quantity"]. The
 * default variant stays in input[name="id"], so the theme's shared add-to-cart
 * handler (data-cart-add-async in multi-variant-options.js, which reads name="id" +
 * name="quantity") works with no bespoke cart code here.
 *
 * Per-card prices are computed from the default variant's base price:
 *   compareAt = basePrice * quantity;  discounted = compareAt * (1 - discount%).
 * The actual discount is applied downstream by Shopify's quantity rules — this only
 * displays the bundle price and sets the quantity, exactly like the PDP.
 *
 * No dependencies. Self-initialises every [data-featured-product] element and
 * re-wires itself for the Shopify theme editor.
 */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, moneyFormat);
    }
    var value = (Math.round(Number(cents) || 0) / 100).toFixed(2);
    var amountToken = '{' + '{amount}' + '}';
    return moneyFormat ? moneyFormat.replace(amountToken, value) : value;
  }

  function initPresets(root) {
    var form = root.querySelector('form');
    if (!form) { return; }

    var presetList = form.querySelector('[data-offer-presets]');
    if (!presetList) { return; }

    var presets = Array.prototype.slice.call(presetList.querySelectorAll('[data-offer-preset]'));
    if (!presets.length) { return; }

    var qtyInput = form.querySelector('input[name="quantity"]');
    var basePriceCents = parseInt(presetList.getAttribute('data-base-price'), 10) || 0;
    var moneyFormat = (window.Shopify && Shopify.money_format) || presetList.getAttribute('data-money-format') || '';

    function recompute() {
      presets.forEach(function (card) {
        var q = parseInt(card.dataset.presetQuantity, 10) || 1;
        var dp = parseFloat(card.dataset.presetDiscount || '0');
        var compareAtCents = basePriceCents * q;
        var discountedCents = compareAtCents * (1 - dp / 100);

        var elCalc = card.querySelector('[data-preset-calc]');
        var elPriceWrapper = card.querySelector('[data-preset-price-wrapper]');
        var elPrice = card.querySelector('[data-preset-price]');
        var elCompareAt = card.querySelector('[data-preset-compare-at-price]');
        var elDiscountLabel = card.querySelector('[data-preset-discount-label]');

        // No per-serving data in this section — hide the calc row.
        if (elCalc) { elCalc.classList.add('is-hidden'); }

        if (elPrice) { elPrice.innerHTML = formatMoney(discountedCents, moneyFormat); }

        if (compareAtCents > discountedCents) {
          if (elPriceWrapper) { elPriceWrapper.classList.add('offer-preset__price-wrapper--has-discount'); }
          if (elCompareAt) { elCompareAt.innerHTML = formatMoney(compareAtCents, moneyFormat); }
        } else {
          if (elPriceWrapper) { elPriceWrapper.classList.remove('offer-preset__price-wrapper--has-discount'); }
          if (elCompareAt) { elCompareAt.innerHTML = ''; }
        }

        if (elDiscountLabel) {
          var inferredDiscount = compareAtCents > discountedCents
            ? Math.round((1 - discountedCents / compareAtCents) * 100)
            : 0;
          var displayDiscount = dp > 0 ? Math.round(dp) : inferredDiscount;
          elDiscountLabel.classList.toggle('is-hidden', displayDiscount <= 0);
          elDiscountLabel.textContent = displayDiscount > 0 ? displayDiscount + '% off' : '';
        }
      });
    }

    function setActivePreset(card) {
      presets.forEach(function (c) { c.classList.remove('is-active'); });
      if (!card) {
        form.classList.remove('has-active-preset');
        if (qtyInput) { qtyInput.value = 1; }
        return;
      }
      card.classList.add('is-active');
      form.classList.add('has-active-preset');
      if (qtyInput) {
        qtyInput.value = parseInt(card.dataset.presetQuantity, 10) || 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    presets.forEach(function (card) {
      // product_override cards render as links (no radio input) — skip selection.
      var input = card.parentElement.querySelector('[data-offer-preset-input]');
      if (!input) { return; }
      input.addEventListener('change', function () {
        if (input.checked) { setActivePreset(card); }
      });
    });

    recompute();

    var initiallyChecked = presets.find(function (card) {
      var input = card.parentElement.querySelector('[data-offer-preset-input]');
      return input && input.checked;
    });
    if (initiallyChecked) { setActivePreset(initiallyChecked); }
  }

  function init(root) {
    if (!root || root.hasAttribute('data-fp-ready')) { return; }
    root.setAttribute('data-fp-ready', 'true');
    initPresets(root);
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-featured-product]');
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support — re-init when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-featured-product]') : null;
    if (root) {
      root.removeAttribute('data-fp-ready');
      init(root);
    }
  });
})();
